export default __webpack_public_path__ + "static/media/velaYellow.b4e79cbd.png";